import {Carousel} from "flowbite-react";
import { useTranslation } from 'react-i18next';
import {homeBanners} from "../data/banners";

const theme = {
    "root": {
        "base": "relative min-w-full h-full xl:h-[calc(100vh-6rem)]",
        "leftControl": "absolute left-0 top-0 flex h-full items-center justify-center px-4 focus:outline-none",
        "rightControl": "absolute right-0 top-0 flex h-full items-center justify-center px-4 focus:outline-none"
    }, "indicators": {
        "active": {
            "off": "bg-white/50 w-8", "on": "bg-white w-12"
        },
        "base": "h-1.5 w-6 rounded-sm",
        "wrapper": "absolute bottom-4 left-1/2 flex -translate-x-1/2 space-x-2"
    }, "item": {
        "base": "absolute left-1/2 top-1/2 block w-full -translate-x-1/2 -translate-y-1/2",
        "wrapper": {
            "off": "w-full flex-shrink-0 transform cursor-default snap-center",
            "on": "w-full flex-shrink-0 transform cursor-grab snap-center"
        }
    }, "control": {
        "base": "flex h-8 w-8 md:h-12 md:w-12 items-center justify-center group-hover:bg-white/30",
        "icon": "h-8 w-8 md:h-12 md:w-12 text-white dark:text-gray-800"
    }, "scrollContainer": {
        "base": "flex h-full snap-mandatory overflow-y-hidden overflow-x-scroll scroll-smooth ease-out duration-800",
        "snap": "snap-x"
    }
}

function IntroSection() {
    const { t } = useTranslation();
    return (
        <Carousel theme={theme} slideInterval={8000}>
            {homeBanners.map((banner, index) => (
                <IntroBanner img={banner.img} title={t(banner.title)}
                             subtitle={t(banner.subtitle)} key={index}/>
            ))}
        </Carousel>
    );
}

export default IntroSection;

const IntroBanner = ({img, title, subtitle}) => {
    return (
        <>
            <img src={img} alt={title} className="object-cover brightness-75 min-h-96 min-w-full"/>
            <div className="absolute inset-0 flex-col place-content-center whitespace-pre-wrap font-bold">
                <h1 data-aos="fade-in"
                    data-aos-duration="2000"
                    className="[text-shadow:_0_0px_4px_rgb(00_00_00_/_0.25)]
                   text-white leading-relaxed max-md:leading-tight text-4xl max-md:text-2xl">
                    {title}
                </h1>
                <h2 data-aos="fade-up"
                    className="[text-shadow:_0_0px_4px_rgb(00_00_00_/_0.25)]
                   text-white text-2xl max-md:text-sm leading-normal mt-8 max-md:mt-4">
                    {subtitle}
                </h2>
            </div>
        </>
    );
}
